import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import AlertBox from '@/components/AlertBox';
import GeneralLoading from '@/components/GeneralLoading';

import WarehouseCard from './dependencies/warehouse-card';
import { useWarehousesSection } from './use-warehouses-section';

const WarehousesSection = () => {
  const hooks = useWarehousesSection();
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: theme.spacing(3),
        gap: theme.spacing(3),
      }}
    >
      <div className="flex items-center gap-2">
        <Typography variant="subtitle2" sx={{ color: theme.palette.secondary.main }}>
          Almacenes activos
        </Typography>
        <Chip
          label={hooks.warehouses.length}
          size="small"
          color="primary"
          sx={{ fontWeight: theme.typography.fontWeightBold }}
        />
      </div>

      {hooks.isLoading && (
        <div className="flex justify-center py-10">
          <GeneralLoading size={40} text="Cargando almacenes" />
        </div>
      )}

      {!hooks.isLoading && hooks.error && (
        <AlertBox type="error">
          <Typography variant="body2">{hooks.error}</Typography>
        </AlertBox>
      )}

      {!hooks.isLoading && !hooks.error && hooks.isEmpty && (
        <div className="flex flex-col items-center gap-2 py-10">
          <WarehouseOutlined sx={{ fontSize: 64, color: theme.palette.grey[300] }} />
          <Typography variant="body1" sx={{ color: theme.palette.grey[600] }}>
            No tienes almacenes activos por el momento.
          </Typography>
        </div>
      )}

      {!hooks.isLoading && !hooks.error && !hooks.isEmpty && (
        <Grid container spacing={3}>
          {hooks.warehouses.map((warehouse) => (
            <Grid key={warehouse._id} size={{ xxs: 12, md: 6, xxl: 4 }}>
              <WarehouseCard warehouse={warehouse} />
            </Grid>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

export default WarehousesSection;
